
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M6 13.223L8.45 16.7a1.049 1.049 0 001.707.051L18 6.828"}}),_c('rect',{staticClass:"a",attrs:{"x":".75","y":".749","width":"22.5","height":"22.5","rx":"1.5","ry":"1.5"}})])
          )
        }
      }
    